const QRScanner = require('./scripts/scanner.js')
//export default QRScanner
module.exports = QRScanner
